//polyfills
//принудительно применять полифилл, даже если браузер поддерживает
//Например хром какого-то хрена докручивает не до верха страницы, а к середине
//@ts-ignore
window.__forceSmoothScrollPolyfill__ = true;
import {polyfill} from  'smoothscroll-polyfill';
polyfill();

//polyfills end

//api
import api from './helpers/api'
window.api = api;

//main.js
import debounce from 'lodash/debounce';
import {onReady} from './helpers/helpers';

import PreloaderPage from './includes/PreloaderPage'
import bodyLocker from './JE/bodyLocker';

import Vue from 'vue';
import store from './store'

//это не vue-компонент, а код сделаный по старинке. Переписать.

import PageProjects from './layout/PageProjects';

import modalBox from './components/modal-box.vue'
import formContact from './components/form-contact.vue'
import blickComp from './components/blick-comp.vue'
import threeArrowsComp from './components/three-arrows-comp.vue'
import modalGallery from './components/modal-gallery.vue'


import buttonHamburger from './includes/ButtonHamburger'
import blockMobileMenuWrapper from './includes/BlockMobileMenuWrapper'
import callToAction from './includes/CallToAction'
import slidersOnMain from './includes/SlidersOnMain'
import PointerToProjectDescription from './includes/PointerToProjectDescription'
import LinkToProjectCool from './includes/LinkToProjectCool'
import ProjectBrowser from './includes/ProjectBrowser'
import ProjectMobile from './includes/ProjectMobile'
import SlideProjectTexts from './includes/SlideProjectTexts'
import CoolFeaturesSlider from './includes/CoolFeaturesSlider.js'

import VeeValidate, { Validator } from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru';
import messagesRu from './strings/validator/messages/ru.js';
import attributesRu from './strings/validator/attributes/ru.js';
import customRu from './strings/validator/custom/ru.js';

import {Subject} from "rxjs/Subject";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/throttleTime";
import onNodePropertyChange from "./JE/onNodePropertyChange";

Validator.localize('ru', ru);
Vue.use(VeeValidate, {
  locale: 'ru',	//по умолчанию английская
  dictionary: {
    ru: { //все 3 свойства не обьязательные
      messages: messagesRu,
      attributes: attributesRu,
      custom: customRu,
    }
  },
  aria: false
});

new Vue({
  el: '#app',
  name: 'app',
  store,
  data: {
    //тут лежат потоки событий
    showBlick$: new Subject(),  //interface
  },
  components: {
    buttonHamburger,
    blockMobileMenuWrapper,
    modalBox,
    formContact,
    callToAction,
    slidersOnMain,
    PointerToProjectDescription,
    LinkToProjectCool,
    blickComp,
    ProjectBrowser,
    ProjectMobile,
    threeArrowsComp,
    SlideProjectTexts,
    CoolFeaturesSlider,
    modalGallery

  },
  computed: {
    window(){return window}, // это ваще нужно?

    resolution() {
      return this.$store.getters['getResolution'];
    },
    scroll() {
      return this.$store.getters['getScroll'];
    },
    isSmall() {
      return this.$store.getters['isHeaderSmall']
    },
    //да, блин, здесь то-же что и в isSmall. Так получилось когда выпиливал Barba
    isHeaderSmall() {
      return this.$store.getters['isHeaderSmall']
    },
    isBodyLocked() {
      return this.$store.getters['isBodyLocked']
    },

  },
  watch: {
    isBodyLocked(newVal) {
      let body = document.querySelector('body');
      if (newVal) {
        bodyLocker.lock();
      } else {
        bodyLocker.unlock();
      }
    }
  },
  methods: {
    updateScroll: function () {
      store.commit('setScroll', window.pageYOffset)
    },
    updateResolution: function () {
      store.commit('setResolution', window.innerWidth)
    },
    updateBodyScrollbarWidht: function () {
      let widthWithScrollbar = window.innerWidth;
      let widthWithoutScrollbar = document.documentElement.clientWidth;
      let widthScrollbar = widthWithScrollbar - widthWithoutScrollbar;
      document.documentElement.style.setProperty('--scrollBarWidth', widthScrollbar + 'px');

    },
    updateVH(){
      // создать переменную для vh - без нее, блять, в хроме на мобилах налазит адресбар и в итоге нихера не влазит в высоту
      // let vh = window.innerHeight * 0.01;
      let vh = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      // console.log(vh)
    }
  },
  mounted(){
    new PageProjects(); //переписать блять во вьюшному

    window.addEventListener('scroll', debounce(this.updateScroll, 10));
    this.updateScroll();

    window.addEventListener('resize', debounce(this.updateResolution, 25));
    this.updateResolution();

    onNodePropertyChange(document.documentElement, 'clientWidth', this.updateBodyScrollbarWidht)
    this.updateBodyScrollbarWidht();


    // именно resize. так onNodePropertyChange(document.documentElement, 'clientHeight', this.updateVH) не избавляет от пролем с хромом.
    window.addEventListener('resize', this.updateVH);

    this.updateVH();

    let preloaderPage = new PreloaderPage();
    onReady(() => {
      // да,это реально срабатывает на ready, а не на load. Проверил. т.е. когда загрузился js а картинки ещё не загрузились.
      preloaderPage.hide();
    })
    window.addEventListener('beforeunload', ()=> {
      // показывать перед уходом со страницы
      preloaderPage.showOnUnload();
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js